import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Logo from "../elements/logo/Logo";
import LoginForm from "./LoginForm";
import LoginConfirmForm from "./LoginConfirmForm";
import axios from "axios";
import Cookies from "js-cookie";
import Notification from "../elements/notification/Notification";
import GoogleForm from "./GoogleForm";

import { StyledLoginFormHead, StyledLoginFormWrapper, StyledLoginWrapper, StyleFormTitle } from "./styledLogin";
import { STANDARD_ERRORS_WAY, SUPPORTED_LANGUAGES } from "../../utils/consts";
import getLanguageFromUrl from "../../utils/getLanguageFromUrl";
import { useTranslation } from "react-i18next";
import { parseAxiosError } from "../../utils/response";

const LoginContainer = ({ selectedLanguage = SUPPORTED_LANGUAGES[getLanguageFromUrl()].url }) => {
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("loginPage")

  const [authData, setAuthData] = useState({
    responseGoogleToken: null,
    authConfig: null
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleGoBack = () => {
    setAuthData({
      responseGoogleToken: null,
      authConfig: null
    });
  };

  const saveTokenAndRedirect = (token) => {
    Cookies.set("token", token);
    if (Cookies.get("token")) {
      window.location.replace(`/${selectedLanguage.replace("/", "")}`);
    }
  };

  const handleSubmit = (data) => {
    data.preventDefault();
    setLoading(true);
    axios.post("/api", { "2fa": data.target.twofa.value }, authData.authConfig).then(response => {
      saveTokenAndRedirect(response.data.data.attributes.token);
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setLoading(false);
    });
  };

  const renderStep = () => {
    if (authData.authConfig || authData.responseGoogleToken) {
      return (
        <LoginConfirmForm
          handleSubmit={handleSubmit}
          handleGoBack={handleGoBack}
          error={error}
          loading={loading}
          t={t}
        />
      );
    }

    return (
      <React.Fragment>
        <StyledLoginFormHead>
          <StyleFormTitle as="h2">
            {t("loginTitle")}
          </StyleFormTitle>
        </StyledLoginFormHead>
        <GoogleForm
          authData={authData}
          setAuthData={setAuthData}
          notification={notification}
          setNotification={setNotification}
          t={t}
        />
        <LoginForm
          onPasswordAccepted={(authConfig) => setAuthData({ ...authData, authConfig })}
          onTokenIssued={saveTokenAndRedirect}
          notification={notification}
          setNotification={setNotification}
          t={t}
        />
      </React.Fragment>
    );
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledLoginWrapper>
        <Helmet>
          <title>{t("loginMetaTitle")} • eXsoft.io</title>
        </Helmet>
        <Logo className="logo" />
        <StyledLoginFormWrapper>
          {renderStep()}
        </StyledLoginFormWrapper>
      </StyledLoginWrapper>
    </>
  );
};

export default LoginContainer;
